import React, { useState } from 'react';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { AssessmentContent } from './components/AssessmentContent';
import { AnalyticsDashboard } from './components/AnalyticsDashboard';
import { FeedbackPage } from './components/FeedbackPage';
import { AdminHub } from './pages/AdminHub';
import { ReportsPage } from './pages/ReportsPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { ProfilePage } from './pages/ProfilePage';
import { AlertsPage } from './pages/AlertsPage';
import { BulkUploadResultsPage } from './pages/BulkUploadResultsPage';
import { InsightsActionsPage } from './pages/InsightsActionsPage';
import { GlobalPhoebeChat } from './components/GlobalPhoebeChat';
import { PhoebeOnboarding } from './components/PhoebeOnboarding';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
function App() {
  return <BrowserRouter data-id="element-0" data-mp="23ujjma5idj2g">
      <div className="flex h-screen bg-gray-50" data-id="element-1" data-mp="23v2sl1d6kx4c">
        <Sidebar data-id="element-2" data-mp="3ikh98cxzsz0k" />
        <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3" data-mp="3iiwfuqnezm4a">
          <Header data-id="element-4" data-mp="3mlawr57iwbsx" />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50" data-id="element-5" data-mp="3mkre1ma1tjdu">
            <Routes data-id="element-6" data-mp="3rcj7c4kla37o">
              <Route path="/" element={<Navigate to="/admin" replace data-id="element-8" data-mp="3rcsyvwla8ifh" />} data-id="element-7" data-mp="3rbzq6q2rjiup" />
              <Route path="/admin" element={<AdminHub data-id="element-10" data-mp="4wxfu7a14id" />} data-id="element-9" data-mp="5or2zhbcs60" />
              <Route path="/analytics" element={<AnalyticsDashboard data-id="element-12" data-mp="2zl3dbpgpde7f" />} data-id="element-11" data-mp="56m9egl55mh" />
              <Route path="/assessment" element={<UserManagementPage data-id="element-14" data-mp="2zn6bwxvx8fnr" />} data-id="element-13" data-mp="2zmepodo7rua5" />
              <Route path="/feedback" element={<ReportsPage data-id="element-16" data-mp="33ngiabnml835" />} data-id="element-15" data-mp="33m5c656pjo8v" />
              <Route path="/profile" element={<ProfilePage data-id="element-18" data-mp="38l8gtoirzsgb" />} data-id="element-17" data-mp="33oi2p6qj76xj" />
              <Route path="/settings" element={<Navigate to="/profile?tab=settings" replace data-id="element-20" data-mp="3dle3eqa6uorj" />} data-id="element-19" data-mp="38l00tnrcw70w" />
              <Route path="/alerts" element={<AlertsPage data-id="element-22" data-mp="nwc0jp6vnpuo" />} data-id="element-21" data-mp="nvj2rdpwcaoo" />
              <Route path="/insights-actions" element={<InsightsActionsPage data-id="element-24" data-mp="stkm7zr8ic0o" />} data-id="element-23" data-mp="nv1284w7baay" />
              <Route path="/bulk-upload-results" element={<BulkUploadResultsPage data-id="element-26" data-mp="34nbhsjeuzx5" />} data-id="element-25" data-mp="swgm3tmn7arr" />
            </Routes>
          </main>
          <GlobalPhoebeChat data-id="element-27" data-mp="3uc9inv5c9kir" />
          <PhoebeOnboarding data-id="element-28" data-mp="3uf5m1yzyh1el" />
        </div>
      </div>
    </BrowserRouter>;
}
export { App };